import React, { useEffect, useState } from "react";
import { formatDateTime } from "../../../utils/timeUtils";
import {
  addApplicantNote,
  deleteApplicantNote,
  pinApplicantNote,
  subscribeApplicantNotes,
  unpinApplicantNote,
  updateApplicantNote,
} from "../../../services/firestoreApplicantNotes";
import {
  uploadApplicantNoteAttachment,
} from "../../../services/firestoreApplicantAttachments";


const DOCUMENT_TYPES = [
  {
    key: "government_id",
    label: "Government ID",
    icon: "🪪",
  },
  {
    key: "professional_license",
    label: "Professional License",
    icon: "📜",
  },
  {
    key: "cpr_bls",
    label: "CPR / BLS",
    icon: "❤️",
  },
  {
    key: "tb_test",
    label: "TB Test",
    icon: "🩺",
  },
  {
    key: "background_check",
    label: "Background Check",
    icon: "🔍",
  },
];

export default function Applicant360Panel({
  profile,
  applicant,
  open,
  onClose,
  onOpenWorker,
  onReviewDocuments,
  onApproveApplicant,
  onSendReminder,
}) {

const [noteText, setNoteText] = useState("");

const [notes, setNotes] = useState([]);

const [noteAttachments, setNoteAttachments] = useState([]);

const [editingNoteId, setEditingNoteId] = useState(null);
const [editingNoteText, setEditingNoteText] = useState("");

const applicantSource =
  String(applicant?.source || "").toLowerCase();

const applicantRecordId =
  applicantSource === "invite"
    ? applicant?.inviteId ||
      applicant?.id ||
      applicant?.email
    : applicant?.uid ||
      applicant?.id ||
      applicant?.email;

  const applicantId = applicantRecordId
  ? `${applicantSource || "applicant"}:${String(
      applicantRecordId
    )
      .trim()
      .toLowerCase()}`
  : "";

const applicantTenantId = String(
  applicant?.tenantId ||
    profile?.tenantId ||
    profile?.tenantKey ||
    ""
)
  .trim()
  .toLowerCase();

const applicantFacilityId = String(
  applicant?.facilityId ||
    applicant?.primaryFacilityId ||
    profile?.facilityId ||
    profile?.primaryFacilityId ||
    (Array.isArray(applicant?.facilityIds)
      ? applicant.facilityIds[0]
      : "") ||
    (Array.isArray(profile?.facilityIds)
      ? profile.facilityIds[0]
      : "") ||
    ""
)
  .trim()
  .toLowerCase();

useEffect(() => {
  if (!open) return undefined;

  function handleKeyDown(event) {
    if (event.key === "Escape") {
      onClose?.();
    }
  }

  window.addEventListener("keydown", handleKeyDown);

  return () => {
    window.removeEventListener("keydown", handleKeyDown);
  };
}, [open, onClose]);

useEffect(() => {
  if (!open || !applicantId) {
    setNotes([]);
    return undefined;
  }

  if (
    !applicantTenantId ||
    !applicantFacilityId
  ) {
    console.warn(
      "Applicant notes listener not started — missing scope",
      {
        applicantId,
        tenantId:
          applicantTenantId,
        facilityId:
          applicantFacilityId,
        applicantEmail:
          applicant?.email,
      }
    );

    setNotes([]);
    return undefined;
  }

  console.log(
    "APPLICANT 360 NOTES SUBSCRIBE",
    {
      applicantId,
      tenantId:
        applicantTenantId,
      facilityId:
        applicantFacilityId,
    }
  );

  const unsubscribe =
    subscribeApplicantNotes(
      applicantId,
      setNotes,
      {
        tenantId:
          applicantTenantId,

        facilityId:
          applicantFacilityId,
      }
    );

  return () => {
    unsubscribe?.();
  };
}, [
  open,
  applicantId,
  applicantTenantId,
  applicantFacilityId,
  applicant?.email,
]);

if (!open || !applicant) return null;


async function addRecruiterNote() {
  const text = noteText.trim();

 if (!text && noteAttachments.length === 0) {
  alert("Enter a note or select at least one attachment.");
  return;
}

  try {
let attachments = [];

if (noteAttachments.length > 0) {
attachments = await Promise.all(
  noteAttachments.map((file) =>
    uploadApplicantNoteAttachment({
      applicantId,
      file,
    })
  )
);
}

await addApplicantNote({
  applicantId,

  tenantId:
    applicantTenantId,

  facilityId:
    applicantFacilityId,

  note: text,

  createdBy:
    profile?.uid || "system",
  createdByName:
    profile?.displayName || "Administrator",
  attachments,
});

    setNoteText("");
    setNoteAttachments([]);
 
   } catch (error) {
  console.error("Unable to save recruiter note:", {
    code: error?.code,
    message: error?.message,
    name: error?.name,
    error,
  });

  alert(
    `Unable to save recruiter note.\n\n` +
    `Code: ${error?.code || "unknown"}\n` +
    `Message: ${error?.message || "No message"}`
  );
} 

}

  function handleSendReminder() {
  if (typeof onSendReminder === "function") {
    onSendReminder(applicant);
    return;
  }

  const email = String(applicant.email || "").trim();

  if (!email) {
    alert("This applicant does not have an email address.");
    return;
  }

  const name =
    applicant.displayName ||
    applicant.fullName ||
    applicant.name ||
    applicant.firstName ||
    "Applicant";

  const subject = encodeURIComponent(
    "Reminder: Complete your ShiftBridge application"
  );

  const body = encodeURIComponent(
    `Hello ${name},

This is a reminder to complete your ShiftBridge Staffing application and submit any outstanding registration information or required documents.

Please sign in to your account and complete the remaining steps.

Thank you,
DogeBridge Staffing`
  );

  window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
}

  const displayName =
    applicant.displayName ||
    applicant.fullName ||
    applicant.name ||
    `${applicant.firstName || ""} ${applicant.lastName || ""}`.trim() ||
    "Applicant";

  const role =
    applicant.primaryRole ||
    applicant.position ||
    applicant.workerType ||
    "Worker";

  const stage =
    applicant.pipelineStage ||
    applicant.onboardingStatus ||
    applicant.workerStatus ||
    "invited";

  const progressSteps = [
    {
      label: "Registration",
      complete:
        applicant.registrationStatus === "approved" ||
        applicant.registrationApproved === true,
    },
    {
      label: "Documents submitted",
      complete:
        applicant.onboardingStatus === "submitted" ||
        applicant.onboardingStatus === "pending_review" ||
        applicant.onboardingStatus === "approved",
    },
    {
      label: "Compliance approved",
      complete: applicant.complianceStatus === "approved",
    },
    {
      label: "Ready for shifts",
      complete:
        applicant.workerStatus === "ready" ||
        applicant.pipelineStage === "approved" ||
        applicant.status === "active",
    },
  ];

  const timelineEvents = [];

timelineEvents.push({
  icon: "📨",
  label: "Applicant invited",
  time: formatDateTime(applicant.invitedAt, "Invitation sent"),
});

if (
  applicant.registrationApproved ||
  applicant.registrationStatus === "approved"
) {
  timelineEvents.push({
    icon: "👤",
    label: "Registration approved",
    time: formatDateTime(applicant.registrationApprovedAt, "Completed"),
  });
}

if (applicant.credentialMap?.government_id?.fileUrl) {
  timelineEvents.push({
    icon: "🪪",
    label: "Government ID uploaded",
    time: formatDateTime(applicant.credentialMap.government_id.uploadedAt, "Uploaded"),
  });
}

if (applicant.credentialMap?.professional_license?.fileUrl) {
  timelineEvents.push({
    icon: "📜",
    label: "Professional License uploaded",
    time: formatDateTime(applicant.credentialMap.professional_license.uploadedAt, "Uploaded"),
  });
}

if (applicant.credentialMap?.cpr_bls?.fileUrl) {
  timelineEvents.push({
    icon: "❤️",
    label: "CPR/BLS uploaded",
    time: formatDateTime(applicant.credentialMap.cpr_bls.uploadedAt, "Uploaded"),
  });
}

if (applicant.credentialMap?.tb_test?.fileUrl) {
  timelineEvents.push({
    icon: "🩺",
    label: "TB Test uploaded",
    time: formatDateTime(applicant.credentialMap.tb_test.uploadedAt, "Uploaded"),
  });
}

if (applicant.complianceStatus === "approved") {
  timelineEvents.push({
    icon: "✅",
    label: "Compliance approved",
    time: formatDateTime(applicant.reviewedAt, "Approved"),
  });
}

if (
  applicant.workerStatus === "ready" ||
  applicant.pipelineStage === "approved"
) {
  timelineEvents.push({
    icon: "🟢",
    label: "Ready for shifts",
    time: formatDateTime(applicant.readyAt, "Ready"),
  });
}

  return (
    <>
      <button
        type="button"
        aria-label="Close applicant profile"
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          border: 0,
          padding: 0,
          margin: 0,
          background: "rgba(15, 23, 42, 0.42)",
          zIndex: 9998,
          cursor: "default",
        }}
      />

      <aside
        role="dialog"
        aria-modal="true"
        aria-label={`${displayName} applicant profile`}
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          bottom: 0,
          width: "min(560px, 100vw)",
          background: "#f8fafc",
          borderLeft: "1px solid #dbe4ee",
          boxShadow: "-18px 0 45px rgba(15, 23, 42, 0.18)",
          zIndex: 9999,
          overflowY: "auto",
        }}
      >
        <div
          style={{
            position: "sticky",
            top: 0,
            zIndex: 2,
            background: "rgba(255, 255, 255, 0.96)",
            backdropFilter: "blur(12px)",
            borderBottom: "1px solid #e2e8f0",
            padding: 18,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: 14,
            }}
          >
            <div style={{ minWidth: 0 }}>
              <div
                style={{
                  fontSize: 12,
                  color: "#64748b",
                  fontWeight: 900,
                  textTransform: "uppercase",
                  letterSpacing: 0.6,
                }}
              >
                Applicant 360
              </div>

              <div
                style={{
                  marginTop: 5,
                  fontSize: 24,
                  color: "#0f172a",
                  fontWeight: 950,
                  lineHeight: 1.15,
                  wordBreak: "break-word",
                }}
              >
                {displayName}
              </div>

              <div
                style={{
                  marginTop: 8,
                  display: "flex",
                  alignItems: "center",
                  gap: 7,
                  flexWrap: "wrap",
                }}
              >
                <span style={rolePillStyle}>
                  {String(role).toUpperCase()}
                </span>

                <span style={stagePillStyle}>
                  {String(stage)
                    .replaceAll("_", " ")
                    .toUpperCase()}
                </span>
              </div>
              <div
                style={{
                  marginTop: 12,
                  display: "grid",
                  gap: 6,
                  color: "#64748b",
                  fontSize: 12,
                  fontWeight: 700,
                }}
              >
                <div>
                  {applicant.facilityName ||
                    applicant.primaryFacilityName ||
                    "No facility selected"}
                </div>

                <div>
                  {applicant.city || "Unknown City"}
                  {applicant.state ? `, ${applicant.state}` : ""}
                </div>

                <div>
                  {applicant.yearsExperience || 0} yrs experience
                  {" • "}
                  {applicant.travelRadiusMiles || 25} mile radius
                </div>
              </div>
            </div>

            <button
              type="button"
              onClick={onClose}
              aria-label="Close applicant profile"
              style={closeButtonStyle}
            >
              ×
            </button>
          </div>
        </div>

        <div
          style={{
            padding: 18,
            display: "grid",
            gap: 18,
          }}

        >
<section style={cardStyle}>
  {(() => {
    const completed = progressSteps.filter(
      (s) => s.complete
    ).length;

    const percent = Math.round(
      (completed / progressSteps.length) * 100
    );

    let color = "#f59e0b";
    let bg = "#fef3c7";
    let icon = "🟡";
    let title = "Needs Documents";

    if (percent >= 100) {
      color = "#16a34a";
      bg = "#dcfce7";
      icon = "🟢";
      title = "Ready for Shifts";
    } else if (percent >= 75) {
      color = "#2563eb";
      bg = "#dbeafe";
      icon = "🔵";
      title = "Ready for Review";
    }

    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <div
            style={{
              fontSize: 12,
              fontWeight: 900,
              color: "#64748b",
              textTransform: "uppercase",
            }}
          >
            Applicant Readiness
          </div>

          <div
            style={{
              marginTop: 6,
              fontSize: 34,
              fontWeight: 950,
              color,
            }}
          >
            {percent}%
          </div>

          <div
            style={{
              marginTop: 6,
              color,
              fontWeight: 900,
            }}
          >
            {icon} {title}
          </div>
        </div>

        <div
          style={{
            width: 82,
            height: 82,
            borderRadius: "50%",
            background: bg,
            display: "grid",
            placeItems: "center",
            fontSize: 34,
          }}
        >
          🎯
        </div>
      </div>
    );
  })()}
</section>

<section style={cardStyle}>
  <div style={sectionTitleStyle}>
    Recruiter Intelligence
  </div>

  {(() => {
    const registrationComplete =
      applicant.registrationStatus === "approved" ||
      applicant.registrationApproved;

    const complianceApproved =
      applicant.complianceStatus === "approved";

    const ready =
      applicant.workerStatus === "ready" ||
      applicant.pipelineStage === "approved";

    const missingDocs = DOCUMENT_TYPES.filter((doc) => {
      const credential =
        applicant.credentialMap?.[doc.key] ||
        applicant.documents?.[doc.key];

      return !credential?.fileUrl;
    });

    let priority = "HIGH";
    let priorityColor = "#dc2626";
    let recommendation = "Complete registration.";

    if (
      registrationComplete &&
      missingDocs.length > 0
    ) {
      recommendation =
        "Request remaining documents.";
    }

    if (
      registrationComplete &&
      missingDocs.length === 0 &&
      !complianceApproved
    ) {
      priority = "MEDIUM";
      priorityColor = "#d97706";
      recommendation =
        "Review submitted documents.";
    }

    if (ready) {
      priority = "READY";
      priorityColor = "#16a34a";
      recommendation =
        "Assign the applicant to their first shift.";
    }

    return (
      <>
        <div
          style={{
            marginTop: 14,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontWeight: 900,
              color: "#64748b",
            }}
          >
            Priority
          </div>

          <div
            style={{
              color: priorityColor,
              fontWeight: 900,
            }}
          >
            {priority}
          </div>
        </div>

        <div
          style={{
            marginTop: 16,
            display: "grid",
            gap: 8,
          }}
        >
          {registrationComplete ? (
            <div>✅ Registration approved</div>
          ) : (
            <div>⚠ Registration pending</div>
          )}

          {missingDocs.length ? (
            missingDocs.map((doc) => (
              <div key={doc.key}>
                ⚠ Missing {doc.label}
              </div>
            ))
          ) : (
            <div>✅ Required documents received</div>
          )}

          {complianceApproved ? (
            <div>✅ Compliance approved</div>
          ) : (
            <div>⚠ Awaiting compliance review</div>
          )}
        </div>

        <div
          style={{
            marginTop: 18,
            padding: 12,
            borderRadius: 12,
            background: "#eff6ff",
            border: "1px solid #bfdbfe",
          }}
        >
          <div
            style={{
              fontSize: 12,
              color: "#64748b",
              fontWeight: 900,
              textTransform: "uppercase",
            }}
          >
            Recommended Next Action
          </div>

          <div
            style={{
              marginTop: 6,
              fontWeight: 900,
              color: "#1d4ed8",
            }}
          >
            {recommendation}
          </div>
        </div>
      </>
    );
  })()}
</section>

          <section style={cardStyle}>
            <div style={sectionTitleStyle}>Contact</div>

            <InfoRow
              label="Email"
              value={applicant.email || "Not provided"}
            />

            <InfoRow
              label="Phone"
              value={
                applicant.phone ||
                applicant.phoneNumber ||
                "Not provided"
              }
            />

            <InfoRow
              label="Facility"
              value={
                applicant.facilityName ||
                applicant.primaryFacilityName ||
                applicant.facilityId ||
                "Not assigned"
              }
            />

            <InfoRow
              label="ZIP"
              value={applicant.homeZip || applicant.zip || "Not provided"}
            />
          </section>

          <section style={cardStyle}>
            <div style={sectionTitleStyle}>Application progress</div>

            <div
              style={{
                marginTop: 14,
                display: "grid",
                gap: 14,
              }}
            >
              {progressSteps.map((step) => (
                <div key={step.label}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: 12,
                      alignItems: "center",
                      marginBottom: 7,
                    }}
                  >
                    <div
                      style={{
                        color: "#334155",
                        fontSize: 13,
                        fontWeight: 900,
                      }}
                    >
                      {step.label}
                    </div>

                    <div
                      style={{
                        color: step.complete
                          ? "#15803d"
                          : "#b45309",
                        fontSize: 12,
                        fontWeight: 900,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {step.complete ? "✓ Complete" : "Pending"}
                    </div>
                  </div>

                  <div
                    style={{
                      height: 8,
                      borderRadius: 999,
                      background: "#e2e8f0",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        width: step.complete ? "100%" : "24%",
                        height: "100%",
                        borderRadius: 999,
                        background: step.complete
                          ? "#22c55e"
                          : "#f59e0b",
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section style={cardStyle}>
            <div style={sectionTitleStyle}>Documents</div>

            {DOCUMENT_TYPES.map((documentType) => {
              const credential =
                applicant.credentialMap?.[documentType.key] ||
                applicant.documents?.[documentType.key] ||
                {};

              const status =
                credential.status ||
                (credential.fileUrl
                  ? "pending_review"
                  : "missing");

              const presentation =
                getDocumentStatusPresentation(status);

              return (
                <div
                  key={documentType.key}
                  style={{
                    marginTop: 10,
                    padding: 12,
                    borderRadius: 12,
                    border: "1px solid #e2e8f0",
                    background: "#f8fafc",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      gap: 10,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: 10,
                        alignItems: "center",
                        minWidth: 0,
                      }}
                    >
                      <div style={{ fontSize: 20 }}>
                        {documentType.icon}
                      </div>

                      <div>
                        <div
                          style={{
                            color: "#0f172a",
                            fontSize: 13,
                            fontWeight: 900,
                          }}
                        >
                          {documentType.label}
                        </div>

                        <div
                          style={{
                            marginTop: 3,
                            color: "#64748b",
                            fontSize: 11,
                            fontWeight: 700,
                          }}
                        >
                          {credential.uploadedAt ||
                          credential.fileUrl
                            ? "Document uploaded"
                            : "No document uploaded"}
                        </div>
                      </div>
                    </div>

                    <span
                      style={{
                        borderRadius: 999,
                        padding: "4px 8px",
                        background: presentation.background,
                        color: presentation.color,
                        fontSize: 10,
                        fontWeight: 900,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {presentation.label}
                    </span>
                  </div>

                  {credential.fileUrl ||
                  status === "reupload_required" ||
                  status === "rejected" ? (
                    <div
                      style={{
                        marginTop: 10,
                        display: "flex",
                        gap: 8,
                        flexWrap: "wrap",
                      }}
                    >
                      {credential.fileUrl ? (
                        <button
                          type="button"
                          onClick={() =>
                            window.open(
                              credential.fileUrl,
                              "_blank",
                              "noopener,noreferrer"
                            )
                          }
                          style={documentButtonStyle}
                        >
                          View Document
                        </button>
                      ) : null}

                      {status === "reupload_required" ||
                      status === "rejected" ? (
                        <button
                          type="button"
                          onClick={() =>
                            alert(
                              `Re-upload request for ${documentType.label} will be connected next.`
                            )
                          }
                          style={dangerButtonStyle}
                        >
                          Request Re-upload
                        </button>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              );
            })}
          </section>

<section style={cardStyle}>
  <div style={sectionTitleStyle}>Timeline</div>

  <div
    style={{
      marginTop: 14,
      display: "grid",
      gap: 12,
    }}
  >
    {timelineEvents.map((event) => (
      <div
        key={event.label}
        style={{
          display: "grid",
          gridTemplateColumns: "34px 1fr",
          gap: 12,
          alignItems: "start",
        }}
      >
        <div
          style={{
            width: 30,
            height: 30,
            borderRadius: "50%",
            background: "#eff6ff",
            display: "grid",
            placeItems: "center",
            fontSize: 16,
          }}
        >
          {event.icon}
        </div>

        <div>
          <div
            style={{
              fontWeight: 900,
              color: "#0f172a",
            }}
          >
            {event.label}
          </div>

          <div
            style={{
              marginTop: 2,
              fontSize: 12,
              color: "#64748b",
            }}
          >
            {event.time}
          </div>
        </div>
      </div>
    ))}
  </div>
</section>

          <section style={cardStyle}>
            <div style={sectionTitleStyle}>Availability</div>

            <InfoRow
              label="Schedule"
              value={
                [
                  applicant.availableDays ? "Days" : null,
                  applicant.availableEvenings
                    ? "Evenings"
                    : null,
                  applicant.availableNights ? "Nights" : null,
                  applicant.availableWeekends
                    ? "Weekends"
                    : null,
                ]
                  .filter(Boolean)
                  .join(", ") || "Not provided"
              }
            />

            <InfoRow
              label="Preferred"
              value={
                Array.isArray(applicant.preferredDays) &&
                applicant.preferredDays.length
                  ? applicant.preferredDays.join(", ")
                  : "No preferred days"
              }
            />

            <InfoRow
              label="Radius"
              value={`${applicant.travelRadiusMiles || 0} miles`}
            />

            <InfoRow
              label="Transport"
              value={
                applicant.hasTransportation
                  ? "Transportation available"
                  : "No transportation recorded"
              }
            />
          </section>

      <section style={cardStyle}>
  <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 10,
  }}
>
  <div style={sectionTitleStyle}>
    📝 Internal Recruiter Notes
  </div>

  <div
    style={{
      borderRadius: 999,
      padding: "4px 9px",
      background: "#e2e8f0",
      color: "#334155",
      fontSize: 11,
      fontWeight: 900,
    }}
  >
    {notes.length} Notes
  </div>
</div>

  <textarea
    value={noteText}
    onChange={(e) => setNoteText(e.target.value)}
    placeholder="Add recruiter note..."
    rows={4}
    style={{
      marginTop: 12,
      width: "100%",
      borderRadius: 12,
      border: "1px solid #cbd5e1",
      padding: 12,
      resize: "vertical",
      fontSize: 13,
      boxSizing: "border-box",
    }}
  />

  <div
  style={{
    marginTop: 10,
    display: "grid",
    gap: 8,
  }}
>
<input
  type="file"
  multiple
  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
  onChange={(e) => {
    const files = Array.from(e.target.files || []);
    const MAX_FILE_SIZE = 10 * 1024 * 1024;

    const validFiles = [];

    for (const file of files) {
      if (file.size > MAX_FILE_SIZE) {
        alert(`${file.name} is larger than 10 MB.`);
        continue;
      }

      validFiles.push(file);
    }

    setNoteAttachments((currentFiles) => {
  const merged = [...currentFiles];

  validFiles.forEach((newFile) => {
    const exists = merged.some(
      (existing) =>
        existing.name === newFile.name &&
        existing.size === newFile.size &&
        existing.lastModified === newFile.lastModified
    );

    if (!exists) {
      merged.push(newFile);
    }
  });

  return merged;
});

// Allow selecting the same file again later if needed.
e.target.value = "";
  }}
  style={{
    width: "100%",
    fontSize: 12,
    color: "#475569",
  }}
/>

{noteAttachments.length > 0 ? (
  <div
    style={{
      display: "grid",
      gap: 8,
    }}
  >
    {noteAttachments.map((file, index) => (
      <div
        key={`${file.name}-${file.size}-${index}`}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 10,
          padding: "8px 10px",
          borderRadius: 10,
          background: "#f8fafc",
          border: "1px solid #e2e8f0",
        }}
      >
        <div
          style={{
            minWidth: 0,
            fontSize: 12,
            fontWeight: 800,
            color: "#334155",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          📎 {file.name}
        </div>

        <button
          type="button"
          onClick={() => {
            setNoteAttachments((currentFiles) =>
              currentFiles.filter(
                (_, fileIndex) => fileIndex !== index
              )
            );
          }}
          style={{
            border: "none",
            background: "transparent",
            color: "#dc2626",
            cursor: "pointer",
            fontSize: 12,
            fontWeight: 900,
          }}
        >
          Remove
        </button>
      </div>
    ))}
  </div>
) : null}
</div>

  <button
    type="button"
    onClick={addRecruiterNote}
    style={{
      marginTop: 10,
      width: "100%",
      border: "1px solid #2563eb",
      background: "#2563eb",
      color: "#fff",
      borderRadius: 12,
      padding: "10px 12px",
      fontWeight: 900,
      cursor: "pointer",
    }}
  >
    + Add Note
  </button>

  <div
    style={{
      marginTop: 16,
      display: "grid",
      gap: 10,
    }}
  >
{notes.map((note) => (
<div
  key={note.id}
style={{
  border: note.pinned
    ? "1px solid #f59e0b"
    : "1px solid #e2e8f0",
  borderRadius: 12,
  padding: 12,
  background: note.pinned
    ? "#fffbeb"
    : "#f8fafc",
}}
>
  {editingNoteId === note.id ? (
    <>
      <textarea
        value={editingNoteText}
        onChange={(e) =>
          setEditingNoteText(e.target.value)
        }
        rows={4}
        style={{
          width: "100%",
          borderRadius: 10,
          border: "1px solid #cbd5e1",
          padding: 10,
          resize: "vertical",
          fontSize: 13,
          boxSizing: "border-box",
        }}
      />

      <div
        style={{
          marginTop: 10,
          display: "flex",
          gap: 8,
          justifyContent: "flex-end",
        }}
      >
        <button
          type="button"
          onClick={() => {
            setEditingNoteId(null);
            setEditingNoteText("");
          }}
          style={{
            border: "1px solid #cbd5e1",
            background: "#fff",
            color: "#475569",
            borderRadius: 8,
            padding: "6px 10px",
            cursor: "pointer",
            fontSize: 12,
            fontWeight: 800,
          }}
        >
          Cancel
        </button>

        <button
          type="button"
          onClick={async () => {
            const text = editingNoteText.trim();

            if (!text) {
              alert("Note cannot be empty.");
              return;
            }

            await updateApplicantNote({
              noteId: note.id,
              note: text,
              updatedBy: profile?.uid || "system",
              updatedByName:
                profile?.displayName ||
                profile?.role ||
                "Administrator",
            });

            setEditingNoteId(null);
            setEditingNoteText("");
          }}
          style={{
            border: "1px solid #2563eb",
            background: "#2563eb",
            color: "#fff",
            borderRadius: 8,
            padding: "6px 10px",
            cursor: "pointer",
            fontSize: 12,
            fontWeight: 800,
          }}
        >
          Save
        </button>
      </div>
    </>
  ) : (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: 12,
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontWeight: 800,
            color: "#334155",
            whiteSpace: "pre-wrap",
            lineHeight: 1.5,
            wordBreak: "break-word",
          }}
        >
          {note.note}
        </div>

{(() => {
  const attachments = Array.isArray(note.attachments)
    ? note.attachments
    : note.attachment
      ? [note.attachment]
      : [];

  if (attachments.length === 0) {
    return null;
  }

  return (
    <div
      style={{
        marginTop: 10,
        display: "grid",
        gap: 8,
      }}
    >
      {attachments.map((attachment, index) => (
        <div
          key={
            attachment?.storagePath ||
            attachment?.url ||
            `${attachment?.name || "attachment"}-${index}`
          }
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 10,
            padding: "8px 10px",
            borderRadius: 10,
            background: "#f8fafc",
            border: "1px solid #e2e8f0",
          }}
        >
          <div
            style={{
              minWidth: 0,
              fontSize: 12,
              fontWeight: 800,
              color: "#334155",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            📎 {attachment?.name || `Attachment ${index + 1}`}
          </div>

          {attachment?.url ? (
            <button
              type="button"
              onClick={() => {
                window.open(
                  attachment.url,
                  "_blank",
                  "noopener,noreferrer"
                );
              }}
              style={{
                flexShrink: 0,
                border: "1px solid #cbd5e1",
                background: "#ffffff",
                color: "#2563eb",
                borderRadius: 8,
                padding: "6px 10px",
                fontSize: 11,
                fontWeight: 900,
                cursor: "pointer",
              }}
            >
              Open
            </button>
          ) : null}
        </div>
      ))}
    </div>
  );
})()}

        <div
          style={{
            marginTop: 8,
            fontSize: 11,
            color: "#64748b",
          }}
        >
          {note.createdByName || "Administrator"} •{" "}
          {formatDateTime(note.createdAt, "Just now")}
        </div>

     {formatDateTime(note.updatedAt) && note.lastAction ? (
  <div
    style={{
      marginTop: 3,
      fontSize: 10,
      color: "#94a3b8",
      fontStyle: "italic",
    }}
  >
    {note.lastAction} by{" "}
    {note.updatedByName || "Administrator"} •{" "}
    {formatDateTime(note.updatedAt)}
  </div>
) : null}
      </div>

    <div
  style={{
    display: "flex",
    gap: 6,
    flexShrink: 0,
  }}
>
  <button
    type="button"
    onClick={async () => {
    if (note.pinned) {
  await unpinApplicantNote({
    noteId: note.id,
    updatedBy: profile?.uid || "system",
    updatedByName:
      profile?.displayName ||
      profile?.role ||
      "Administrator",
  });
} else {
  await pinApplicantNote({
    noteId: note.id,
    updatedBy: profile?.uid || "system",
    updatedByName:
      profile?.displayName ||
      profile?.role ||
      "Administrator",
  });
}
    }}
    style={{
      border: note.pinned
        ? "1px solid #d97706"
        : "1px solid #cbd5e1",
      background: note.pinned
        ? "#fffbeb"
        : "#fff",
      color: note.pinned
        ? "#b45309"
        : "#475569",
      borderRadius: 8,
      padding: "6px 10px",
      cursor: "pointer",
      fontSize: 12,
      fontWeight: 800,
    }}
  >
    {note.pinned ? "📌 Unpin" : "📌 Pin"}
  </button>

  <button
    type="button"
    onClick={() => {
      setEditingNoteId(note.id);
      setEditingNoteText(note.note || "");
    }}
          style={{
            border: "1px solid #2563eb",
            background: "#fff",
            color: "#2563eb",
            borderRadius: 8,
            padding: "6px 10px",
            cursor: "pointer",
            fontSize: 12,
            fontWeight: 800,
          }}
        >
          ✏️ Edit
        </button>

        <button
          type="button"
          onClick={async () => {
            const confirmed = window.confirm(
              "Delete this recruiter note?"
            );

            if (!confirmed) return;

            await deleteApplicantNote(note.id);
          }}
          style={{
            border: "1px solid #ef4444",
            background: "#fff",
            color: "#dc2626",
            borderRadius: 8,
            padding: "6px 10px",
            cursor: "pointer",
            fontSize: 12,
            fontWeight: 800,
          }}
        >
          🗑 Delete
        </button>
      </div>
    </div>
  )}
</div>
))}
  </div>
</section>    

<section style={cardStyle}>
  <div style={sectionTitleStyle}>Quick Actions</div>

  <div
    style={{
      marginTop: 12,
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      gap: 10,
    }}
  >
    <button
      type="button"
      style={primaryButtonStyle}
 onClick={() => {
  if (typeof onOpenWorker === "function") {
    onOpenWorker(applicant);
    return;
  }

  console.log("Open worker", applicant);
}}
    >
      👤 Worker
    </button>

    <button
      type="button"
      style={secondaryButtonStyle}
    onClick={() => {
  if (typeof onReviewDocuments === "function") {
    onReviewDocuments(applicant);
    return;
  }

  console.log("Review documents", applicant);
}}
    >
      📄 Documents
    </button>

   <button
  type="button"
  style={secondaryButtonStyle}
  onClick={handleSendReminder}
>
  🔔 Send Reminder
</button>

    <button
      type="button"
      style={secondaryButtonStyle}
      onClick={() => {
        alert("Schedule Follow-up");
      }}
    >
      📅 Follow-up
    </button>

  <button
  type="button"
  style={secondaryButtonStyle}
  onClick={() => {
    if (typeof onApproveApplicant === "function") {
      onApproveApplicant(applicant);
      return;
    }

    console.log("Approve applicant", applicant);
  }}
>
  ✅ Approve Registration
</button>

    <button
      type="button"
      style={secondaryButtonStyle}
      onClick={() => {
        alert("Reject Applicant");
      }}
    >
      ❌ Reject
    </button>
  </div>
</section>
        </div>
      </aside>
    </>
  );
}

function InfoRow({ label, value }) {
  return (
    <div
      style={{
        marginTop: 12,
        display: "grid",
        gridTemplateColumns: "92px minmax(0, 1fr)",
        gap: 12,
        alignItems: "start",
      }}
    >
      <div
        style={{
          color: "#64748b",
          fontSize: 12,
          fontWeight: 900,
        }}
      >
        {label}
      </div>

      <div
        style={{
          color: "#0f172a",
          fontSize: 13,
          fontWeight: 800,
          wordBreak: "break-word",
        }}
      >
        {value}
      </div>
    </div>
  );
}

function getDocumentStatusPresentation(status) {
  if (status === "approved") {
    return {
      label: "Approved",
      color: "#15803d",
      background: "#dcfce7",
    };
  }

  if (status === "pending_review") {
    return {
      label: "Pending Review",
      color: "#b45309",
      background: "#fef3c7",
    };
  }

  if (status === "reupload_required") {
    return {
      label: "Re-upload Required",
      color: "#b91c1c",
      background: "#fee2e2",
    };
  }

  if (status === "rejected") {
    return {
      label: "Rejected",
      color: "#b91c1c",
      background: "#fee2e2",
    };
  }

  return {
    label: "Missing",
    color: "#64748b",
    background: "#f1f5f9",
  };
}

const cardStyle = {
  padding: 16,
  borderRadius: 16,
  background: "#ffffff",
  border: "1px solid #e2e8f0",
  boxShadow: "0 8px 24px rgba(15, 23, 42, 0.04)",
};

const sectionTitleStyle = {
  color: "#0f172a",
  fontSize: 15,
  fontWeight: 950,
};

const rolePillStyle = {
  borderRadius: 999,
  padding: "5px 10px",
  background: "#dbeafe",
  border: "1px solid #93c5fd",
  color: "#1d4ed8",
  fontSize: 11,
  fontWeight: 900,
};

const stagePillStyle = {
  borderRadius: 999,
  padding: "5px 10px",
  background: "#f1f5f9",
  border: "1px solid #cbd5e1",
  color: "#334155",
  fontSize: 11,
  fontWeight: 900,
};

const closeButtonStyle = {
  width: 38,
  height: 38,
  flexShrink: 0,
  borderRadius: 12,
  border: "1px solid #cbd5e1",
  background: "#ffffff",
  color: "#334155",
  fontSize: 20,
  fontWeight: 900,
  cursor: "pointer",
};

const primaryButtonStyle = {
  width: "100%",
  border: "1px solid #2563eb",
  borderRadius: 12,
  padding: "10px 12px",
  background: "#2563eb",
  color: "#ffffff",
  fontSize: 13,
  fontWeight: 900,
  cursor: "pointer",
};

const secondaryButtonStyle = {
  width: "100%",
  border: "1px solid #cbd5e1",
  borderRadius: 12,
  padding: "10px 12px",
  background: "#ffffff",
  color: "#334155",
  fontSize: 13,
  fontWeight: 900,
  cursor: "pointer",
};

const documentButtonStyle = {
  border: "1px solid #2563eb",
  borderRadius: 10,
  padding: "7px 10px",
  background: "#ffffff",
  color: "#2563eb",
  fontSize: 11,
  fontWeight: 900,
  cursor: "pointer",
};

const dangerButtonStyle = {
  border: "1px solid #dc2626",
  borderRadius: 10,
  padding: "7px 10px",
  background: "#ffffff",
  color: "#dc2626",
  fontSize: 11,
  fontWeight: 900,
  cursor: "pointer",
};
